import React from 'react';
import { FaDownload, FaFileMedical, FaHeartPulse, FaHouseMedical } from 'react-icons/fa6';
import nurse from '../../assets/nurse_img.png'
import toast from 'react-hot-toast';
import utils from '../../utils';

const ProcessSection = () => {
    return (
        <section id="patient-process" className=" bg-slate-100 dark:bg-slate-900/30 overflow-hidden relative py-10">
            <div className="mx-auto px-4">
                <div className="grid md:grid-cols-2 gap-16 items-center">
                    <div className="relative">
                        <div className="relative rounded-[3rem] overflow-hidden shadow-2xl border-4 border-white dark:border-slate-800">
                            <img
                                alt="Consultation"
                                className="w-full h-[550px] object-cover"
                                src={nurse}
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
                        </div>
                        <div className="absolute -bottom-10 -right-10 z-5 glass-morphism p-8 rounded-3xl shadow-card-hover border border-white/50 max-w-[320px]">
                            <div className="size-14 rounded-full bg-primary flex items-center justify-center text-white mb-6 shadow-xl shadow-primary/30">
                                <FaHeartPulse className="text-3xl" />
                            </div>
                            <h4 className="text-xl font-black text-slate-900 mb-2">Smart Matching</h4>
                            <p className="text-slate-600 font-medium text-sm leading-relaxed">
                                Our algorithm matches your conditions with qualified nurses nearby. Admin can also assign manually.
                            </p>
                        </div>
                    </div>
                    <div className="space-y-10">
                        <div>
                            <span className="text-primary font-bold text-sm tracking-widest uppercase">The Process</span>
                            <h2 className="text-2xl md:text-3xl font-black text-slate-900 dark:text-white mt-4">
                                Simple steps to <br />
                                personalized care.
                            </h2>
                        </div>

                        <div className="space-y-6">
                            <div className="group flex gap-8 p-6 rounded-2xl hover:bg-white dark:hover:bg-slate-800 transition-all duration-300 hover:shadow-premium">
                                <div className="size-14 rounded-2xl bg-primary text-white flex items-center justify-center shrink-0 font-black text-xl shadow-lg shadow-primary/20 group-hover:scale-110 transition-transform">
                                    <FaDownload className="text-2xl" />
                                </div>
                                <div>
                                    <h4 className="text-xl font-black mb-2 text-slate-900 dark:text-white">Download App</h4>
                                    <p className="text-text-secondary dark:text-slate-400">
                                        Get the HealthConnect app and create your patient profile with basic information and contact details.
                                    </p>
                                </div>
                            </div>

                            <div className="group flex gap-8 p-6 rounded-2xl hover:bg-white dark:hover:bg-slate-800 transition-all duration-300 hover:shadow-premium">
                                <div className="size-14 rounded-2xl bg-white dark:bg-slate-700 text-primary border-2 border-primary flex items-center justify-center shrink-0 font-black text-xl group-hover:scale-110 transition-transform">
                                    <FaFileMedical className="text-2xl" />
                                </div>
                                <div>
                                    <h4 className="text-xl font-black mb-2 text-slate-900 dark:text-white">Add Conditions</h4>
                                    <p className="text-text-secondary dark:text-slate-400">
                                        Tell us about your health conditions, ailments, and care needs so we can find the right nurse for you.
                                    </p>
                                </div>
                            </div>

                            <div className="group flex gap-8 p-6 rounded-2xl hover:bg-white dark:hover:bg-slate-800 transition-all duration-300 hover:shadow-premium">
                                <div className="size-14 rounded-2xl bg-white dark:bg-slate-700 text-primary border-2 border-primary flex items-center justify-center shrink-0 font-black text-xl group-hover:scale-110 transition-transform">
                                    <FaHouseMedical className="text-2xl" />
                                </div>
                                <div>
                                    <h4 className="text-xl font-black mb-2 text-slate-900 dark:text-white">Receive Care</h4>
                                    <p className="text-text-secondary dark:text-slate-400">
                                        Your matched nurse arrives at your home with personalized care tailored to your specific health needs.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="pt-4">
                            <button
                                onClick={() => {
                                    toast.success(utils.comminSoon)
                                }}
                                className="px-10 h-16 bg-primary text-white font-black rounded-2xl hover:bg-primary-hover hover:scale-105 transition-all shadow-premium">
                                Download App Now
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProcessSection;